// extracted by mini-css-extract-plugin
module.exports = {"button":"emojione-view_button__japzm","emoji":"emojione-view_emoji__32Myl"};